export default (action, payload, extraParams = {}) => ({
  type: action,
  payload,
  ...extraParams,
});
